import React, { useContext } from 'react';
import { PageContext } from '../providers/page-provider';
import { HealthAssesment } from '../providers/health-assesment-provider';
import { HealthAssesmentCalculator } from '../layouts/health-assesment-calculator';
import {
  Question,
  StepSummary,
  StepSlider,
  InputPercentagelabeled,
  DoubleStepSlider
} from '../components'

export const StepTwo = () => {
  const { handleNextPage, handlePreviousPage } = useContext(PageContext);
  const { addHealthAssesmentData, healthAssesmentData } = useContext(HealthAssesment);
  const titleStep = "Cashflow";
  const summaryStep = "Okay, thanks. Now, let's start to understand some key metrics about your cash flow";
  const tooltip = "Understanding cashflow can help determine the effectiveness of your collection efforts and the overall efficiency of your revenue-to-cash cycle, as well as provide indicators for future health."
  const dso = parseFloat(healthAssesmentData.cashFlow.a) || 0;
  const monthlyInvoices = parseFloat(healthAssesmentData.cashFlow.b) || 0;
  const firstCustomers = parseFloat(healthAssesmentData.cashFlow.d) || 0;
  const recurrentCustomers = parseFloat(healthAssesmentData.cashFlow.e) || 0;

  const handleNextClick = () => {
    handleNextPage({from: "STEP_TWO", to: "STEP_THREE"});
  };

  const handleBackClick = () => {
    handlePreviousPage({to: "STEP_ONE"});
  };

  const handleChangeInput = (question) => (event) => {
    let { name, value } = event.target;

    if (value === "") {
      value = 0;
    }

    value = parseInt(value)
    addHealthAssesmentData({question, name, value});
    setSliderHandle(name, value)
    const sum = healthAssesmentData.cashFlow.d + healthAssesmentData.cashFlow.e;

    if (sum < 100) {
      const remaining = 100 - sum;
      const total = remaining + healthAssesmentData.cashFlow.e;
      addHealthAssesmentData({question: "cashFlow", name: "e", value: total});
    }
  }

  const handleChange = (question) => (event) => {
    let { name, value } = event.target;
    value = parseInt(value)
    addHealthAssesmentData({question, name, value});
  }

  const setSliderHandle = (name, value) => {
    const rangeSlider = document.getElementById("double-slider");
    if (isNaN(value)) {
      value = 0;
    }
    const firstCustomers = parseFloat(healthAssesmentData.cashFlow.d) || 0;
    const recurrentCustomers = parseFloat(healthAssesmentData.cashFlow.e) || 0;
    const sum = healthAssesmentData.cashFlow.d + healthAssesmentData.cashFlow.e;
    const remaining = 100 - sum;

    if (name === "d") {
      rangeSlider.noUiSlider.set([
        value,
        value + recurrentCustomers
      ]);
    } else if (name === "e") {
      rangeSlider.noUiSlider.set([
        firstCustomers + remaining,
        firstCustomers + value + remaining
      ]);
    }
  }

  const disableButton = () => {
    const hasValueDso = dso === 0;
    const hasValueInvoices = monthlyInvoices === 0;
    const percentCustomersSum = firstCustomers + recurrentCustomers;
    const isTotalPercentComplete = percentCustomersSum === 100;

    return hasValueDso || hasValueInvoices || !isTotalPercentComplete;
  }

  return (
    <HealthAssesmentCalculator>
      <div className="fieldset step-two">
        <StepSummary stepNumber="2" stepTitle={titleStep} stepInfo={summaryStep} hasTooltip={true} tooltipText={tooltip}/>
        <div className="questions">
          <div className="column-left">
            <Question>What is your DSO?</Question>
            <input
              type="number"
              className="normal-input"
              placeholder="0"
              name="a"
              onChange={handleChange("cashFlow")}
              value={healthAssesmentData.cashFlow.a}
            />

            <Question>How many invoices are created on a monthly basis?</Question>
            <input
              type="number"
              className="normal-input"
              placeholder="0"
              name="b"
              onChange={handleChange("cashFlow")}
              value={healthAssesmentData.cashFlow.b}
            />

            <Question>What percentage of monthly invoices are outstanding(# of invoices)?</Question>
            <StepSlider
              min={1}
              max={100}
              minValue="<1%"
              maxValue="100%"
              currency={false}
              valueType="%"
              name="c"
              initalValue={healthAssesmentData.cashFlow.c}
              onChange={handleChange("cashFlow")}
              idSlider="2c-slide"
              idValue="2c-value"
            />
          </div>
          <div className="column-right">
          <div className="right-container">

            <Question>What percentage of customers are first-time vs. returning customers over the past 6 months?</Question>
            <div className="recurrent-customers">
              <InputPercentagelabeled
                className="first"
                name="d"
                onChange={handleChangeInput("cashFlow")}
                value={healthAssesmentData.cashFlow.d}>
                First-time customers
              </InputPercentagelabeled>

              <InputPercentagelabeled
                className="recurrent"
                name="e"
                onChange={handleChangeInput("cashFlow")}
                value={healthAssesmentData.cashFlow.e}>
                Returning customers
              </InputPercentagelabeled>
            </div>

            <DoubleStepSlider
              onChange={handleChange("cashFlow")}
              idSlider="double-slider"
              idValue="double-value"
              valueOne={healthAssesmentData.cashFlow.d}
              valueTwo={healthAssesmentData.cashFlow.e}
            />

          </div>
          </div>

          <footer>
            <button className="btn-white-normal-back" onClick={handleBackClick}><i className="fa fa-angle-left"></i> Back</button>
            <button disabled={disableButton()} className="btn-white-normal" onClick={handleNextClick}>Next Step <i className="fa fa-angle-right"></i></button>
          </footer>
        </div>
      </div>
    </HealthAssesmentCalculator>
  )
}
